/** @jsxImportSource theme-ui */
import { Box, Text, Button as ThemeUiButton } from "theme-ui";

import { SvgOrImg } from "components";
import * as styles from "./ProductButtonWithImage.styles";
import { getHrefWithHostname } from "utils";
import { CustomizeIcon } from "components/icons";

export default function ProductButtonWithImage({
  logo,
  description,
  productImage,
  productLogo,
  productLogoOverlay,
  subText,
  selectLabel = "CUSTOMIZE",
  floatingLabel,
  color,
  backgroundColor,
  backgroundImage,
  isSelected = false,
  isDisabled = false,
  productButtonLinkOverride,
  onClick,
  ...props
}) {
  const onClickHandler = !productButtonLinkOverride ? onClick : null;

  const ctaProps = {
    "aria-label": logo.alt,
    variant: "unstyled",
    "data-attr-track": true,
    "data-attr-analytics-trigger": "product_selection",
    "data-attr-analytics-value": logo.alt,
    onClick: onClickHandler,
    disabled: isDisabled,
    ...props,
  };

  const ProductButtonChildren = () => {
    return (
      <>
        <Box sx={styles.labelBox}>
          {description && (
            <Text variant="h5" sx={styles.description}>
              {description}
            </Text>
          )}

          <Box sx={styles.logosContainer}>
            {productLogo?.url && (
              <Box sx={styles.productLogo}>
                <SvgOrImg
                  type={productLogo?.type}
                  src={productLogo.url}
                  alt={productLogo.alt}
                  sx={productLogo?.styles || {}}
                />
              </Box>
            )}
          </Box>

          {subText && (
            <Text sx={{ ...styles.subText, fontSize: "20px" }}>{subText}</Text>
          )}

          {!isSelected && (
            <Box sx={{ ...styles.selectLabel, fontSize: "20px" }}>
              {selectLabel}
              <CustomizeIcon sx={styles.selectLabelIcon} />
            </Box>
          )}

          {productLogoOverlay?.url && (
            <SvgOrImg
              type={productLogoOverlay?.type}
              src={productLogoOverlay.url}
              alt={productLogoOverlay.alt}
              sx={styles.productLogoOverlay}
            />
          )}
        </Box>

        {floatingLabel && (
          <Box
            sx={styles.floatingLabel({
              styles: floatingLabel.styles,
            })}
          >
            {floatingLabel.text}
          </Box>
        )}
      </>
    );
  };

  if (productButtonLinkOverride) {
    ctaProps.href = getHrefWithHostname(productButtonLinkOverride);
    ctaProps.target = "_blank";
    ctaProps.rel = "noopener noreferrer";
    return (
      <Box
        sx={{
          minWidth: "270px",
        }}
      >
        <a {...ctaProps}>
          <ProductButtonChildren />
        </a>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: "300px",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        textDecoration: "none",
      }}
    >
      <ThemeUiButton {...ctaProps} sx={styles.ProductButtonWithImage}>
        <Box sx={styles.productImage}>
          {productImage?.url && (
            <SvgOrImg
              type={productImage?.type}
              src={productImage.url}
              alt={productImage.alt}
              sx={productImage?.styles || {}}
            />
          )}
        </Box>
        <Box
          sx={styles.cardButton({
            backgroundImage,
            backgroundColor,
            color,
          })}
        >
          <ProductButtonChildren />
        </Box>
      </ThemeUiButton>
    </Box>
  );
}
